import { Redirect } from 'react-router-dom';

const TestNeedsProRedirect = () => <Redirect to="/tests/besoins-pro" />;

export default TestNeedsProRedirect;
